import type { ClientOptionsProviderProps } from './ClientOptionsProvider'
import ClientOptionsProvider from './ClientOptionsProvider'

import type { WithClientOptions } from './withClientOptions'
import withClientOptions from './withClientOptions'
import useClientOptions from './useClientOptions'
import type { ClientOptionsValue } from './ClientOptionsContext'
import ClientOptionsContext from './ClientOptionsContext'

export { ClientOptionsContext, withClientOptions, useClientOptions }
export type { ClientOptionsProviderProps, ClientOptionsValue, WithClientOptions }
export default ClientOptionsProvider
